{
    "actions": {
        "page": {
            "add_merchant_user": "Nouvel utilisateur marchand",
            "delete_multiple_contracts": "Suppression des contrats",
            "add_external_contract": "Créer un contrat externe"
        }
    },
    "filter": {
        "placeholder": {
            "email": "Filtrer par email",
            "label": "Filtrer par libellé"
        }
    },
    "keys": {
        "status": "Statut",
        "email": "Email",
        "last_login_at": "Connecté le",
        "profile": "Profil",
        "created_at": "Créé le",
        "updated_at": "MAJ le"
    },
    "modal": {
        "add_external_contract": {
            "title": "Créer un contrat externe",
            "title1": "Créer un contrat {{externalContractName}}",
            "title2": "Nouveau contrat pour {{merchantName}}",
            "alma": {
                "api_key": "Clé API",
                "pos_ticket_label": "Libellé ticket TPE",
                "pos_ticket_label_indication": "(Unique et lié au contrat - Caractères spéciaux et accents interdits)",
                "pos_ticket_label_placeholder": "12 caractères max.",
                "success": "API key validated successfully !"
            },
            "cbvad": {
                "contract_label": "Libellé",
                "contract_type": "Type de contrat",
                "contract_number": "N° contrat",
                "rank": "Rang",
                "bank_code": "Code banque",
                "x25_address": "Adresse centre de téléparamétrage",
                "success": "Contrat ajouté avec succès !",
                "select": {
                    "contract_type": {
                        "placeholder": "Sélectionner le type de contrat",
                        "CONTACT": "Proximité Contact",
                        "CONTACTLESS": "Proximité Sans Contact",
                        "VAD": "Proximité VAD",
                        "CONTACT_AUTOMATE": "Automate Contact",
                        "CONTACTLESS_AUTOMATE": "Automate Sans Contact"
                    }
                },
                "errors": {
                    "REMOTE_CONFIGURATION_ERROR": "Le téléparamètrage du contrat a échoué",
                    "ALREADY_EXISTS": "Le contrat existe déjà",
                    "UNKNOWN_ERROR": "Une erreur inconnue est survenue."
                }
            }
        },
        "add_merchant_user": {
            "title": "Nouvel utilisateur marchand",
            "success": "Utilisateur marchand ajouté avec succès !",
            "text": "Un lien de téléchargement sera envoyé à l'adresse email de l'utilisateur.",
            "info": "Le lien de téléchargement sera valide pendant 48 heures.",
            "maximum_mails": "(5 adresses mail maximum)",
            "placeholder": "Entrer une adresse ici...",
            "already_exists": "Ce mail existe déjà !",
            "confirmation": "Le mail va être envoyé au destinataire suivant :",
            "confirmation_users": "Le mail va être envoyé aux destinataires suivants :",
            "validate": "Validez pour terminer",
            "add_address": "Ajouter une adresse",
            "remove_address": "Effacer cette adresse"
        }
    },
    "profile": {
        "PROFILE_ADMIN_MERCHANT": "Admin.",
        "PROFILE_STANDARD": "Standard",
        "PROFILE_ADMIN_MERCHANT_main": "Admin. (Principal)",
        "PROFILE_STANDARD_main": "Standard (Principal)"
    },
    "status": {
        "ACTIVE": "Activé",
        "INACTIVE": "Désactivé"
    }
}